import { Navigate, useLocation } from 'react-router-dom';
import { getCaptureLocation } from '@/configs/captureRoutes';

export default function LegacyCaptureRedirect() {
  const location = useLocation();
  return <Navigate to={getCaptureLocation(location)} state={location.state} replace />;
}
